import axios from 'axios';
import Common from './Common';
export default {
    getAll() {
        return axios.get(Common.api + 'seller-login');
    },
    getRegistration1() {
        return axios.get(Common.api + 'buyer-reg-first');
    },
    getUserName(id, i) {
        return axios.get(Common.api + 'check-username-dup/' + id + '/' + i);
    },
    create(data) {
        return axios.post(Common.api + 'buyer-login', data);
    },
    createResgistration1(data) {
        return axios.post(Common.api + 'buyer-reg-first', data);
    },
    createResgistration2(data) {
        return axios.post(Common.api + 'buyer-reg-second', data);
    },
    update(id, data) {
        return axios.put(Common.api + 'seller-login' + id, data);
    }
}